export default "__VITE_PUBLIC_ASSET__f0d10a1f__"